import React from 'react';
import styled from 'styled-components/macro';
import IsLoadingAnim from '../../../components/alerts/IsLoadingAnim';

const RouteLoading = () => {
  return (
    <Loading>
      <IsLoadingAnim />
    </Loading>
  );
};

export default RouteLoading;

const Loading = styled.div`
  align-items: center;
  display: flex;
  height: 90vh;
  justify-content: center;
  width: 100vw;
`;
